import { useQuery } from 'react-query';
import { TournamentAPI } from 'api/admin/tournament';
import { TOURNAMENT } from 'helpers/constants';

export default function useTournament(id) {
  return useQuery([TOURNAMENT, id], () => TournamentAPI.fetchTournament(id));
}
